

export const textStyle = {
 
  typography: {
    fontFamily: 'var(--sdFontFamiliesPrimary)',
    fontWeightRegular: 'var(--sdFontWeightsRegular)',
    fontWeightBold: 'var(--sdFontWeightsBold)',
    fontWeightSemiBold: 'var(--sdFontWeightsSemibold)',
    body: {
      xs: {
        fontFamily: 'var(--sdTypographyBodyXsFontFamily)',
        fontWeight: 'var(--sdTypographyBodyXsFontWeight)',
        fontSize: 'var(--sdFontSizeBodyXs)',
        lineHeight: 'var(--sdLineHeightBodyXs)',
        paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
        link: {
          fontFamily: 'var(--sdTypographyBodyXsLinkFontFamily)',
          fontWeight: 'var(--sdTypographyBodyXsLinkFontWeight)',
          fontSize: 'var(--sdFontSizeBodyXs)',
          lineHeight: 'var(--sdLineHeightBodyXs)',
          paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
          textDecoration: 'var(--sdTextDecorationUnderline)',
        },
        bold: {
          fontFamily: 'var(--sdTypographyBodyXsBoldFontFamily)',
          fontWeight: 'var(--sdTypographyBodyXsBoldFontWeight)',
          fontSize: 'var(--sdFontSizeBodyXs)',
          lineHeight: 'var(--sdLineHeightBodyXs)',
          paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
        },
      },
      sm: {
        fontFamily: 'var(--sdTypographyBodySmFontFamily)',
        fontWeight: 'var(--sdTypographyBodySmFontWeight)',
        fontSize: 'var(--sdFontSizeBodySm)',
        lineHeight: 'var(--sdLineHeightBodySm)',
        paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
        link: {
          fontFamily: 'var(--sdTypographyBodySmLinkFontFamily)',
          fontWeight: 'var(--sdTypographyBodySmLinkFontWeight)',
          fontSize: 'var(--sdFontSizeBodySm)',
          lineHeight: 'var(--sdLineHeightBodySm)',
          paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
          textDecoration: 'var(--sdTextDecorationUnderline)',
        },
        bold: {
          fontFamily: 'var(--sdTypographyBodySmBoldFontFamily)',
          fontWeight: 'var(--sdTypographyBodySmBoldFontWeight)',
          fontSize: 'var(--sdFontSizeBodySm)',
          lineHeight: 'var(--sdLineHeightBodySm)',
          paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
        },
      },
      md: {
        fontFamily: 'var(--sdTypographyBodyMdFontFamily)',
        fontWeight: 'var(--sdTypographyBodyMdFontWeight)',
        fontSize: 'var(--sdFontSizeBodyMd)',
        lineHeight: 'var(--sdLineHeightBodyMd)',
        paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
        link: {
          fontFamily: 'var(--sdTypographyBodyMdLinkFontFamily)',
          fontWeight: 'var(--sdTypographyBodyMdLinkFontWeight)',
          fontSize: 'var(--sdFontSizeBodyMd)',
          lineHeight: 'var(--sdLineHeightBodyMd)',
          paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
          textDecoration: 'var(--sdTextDecorationUnderline)',
        },
        bold: {
          fontFamily: 'var(--sdTypographyBodyMdBoldFontFamily)',
          fontWeight: 'var(--sdTypographyBodyMdBoldFontWeight)',
          fontSize: 'var(--sdFontSizeBodyMd)',
          lineHeight: 'var(--sdLineHeightBodyMd)',
          paragraphSpacing: 'var(--sdParagraphSpacingBodyMd)',
        },
      },
      lg: {
        fontFamily: 'var(--sdTypographyBodyLgFontFamily)',
        fontWeight: 'var(--sdTypographyBodyLgFontWeight)',
        fontSize: 'var(--sdFontSizeBodyLg)',
        lineHeight: 'var(--sdLineHeightBodyLg)',
        paragraphSpacing: 'var(--sdParagraphSpacingBodyLg)',
        link: {
          fontFamily: 'var(--sdTypographyBodyLgLinkFontFamily)',
          fontWeight: 'var(--sdTypographyBodyLgLinkFontWeight)',
          fontSize: 'var(--sdFontSizeBodyLg)',
          lineHeight: 'var(--sdLineHeightBodyLg)',
          paragraphSpacing: 'var(--sdParagraphSpacingBodyLg)',
          textDecoration: 'var(--sdTextDecorationUnderline)',
        },
        bold: {
          fontFamily: 'var(--sdTypographyBodyLgBoldFontFamily)',
          fontWeight: 'var(--sdTypographyBodyLgBoldFontWeight)',
          fontSize: 'var(--sdFontSizeBodyLg)',
          lineHeight: 'var(--sdLineHeightBodyLg)',
          paragraphSpacing: 'var(--sdParagraphSpacingBodyLg)',
        },
      },
    },
    heading: {
      xxs: {
        fontFamily: 'var(--sdTypographyHeadingXxsFontFamily)',
        fontWeight: 'var(--sdTypographyHeadingXxsFontWeight)',
        fontSize: 'var(--sdTypographyHeadingXxsFontSize)',
        lineHeight: 'var(--sdTypographyHeadingXxsLineHeight)',
      },
      xs: {
        fontFamily: 'var(--sdTypographyHeadingXsFontFamily)',
        fontWeight: 'var(--sdTypographyHeadingXsFontWeight)',
        fontSize: 'var(--sdTypographyHeadingXsFontSize)',
        lineHeight: 'var(--sdTypographyHeadingXsLineHeight)',
      },
      sm: {
        fontFamily: 'var(--sdTypographyHeadingSmFontFamily)',
        fontWeight: 'var(--sdTypographyHeadingSmFontWeight)',
        fontSize: 'var(--sdTypographyHeadingSmFontSize)',
        lineHeight: 'var(--sdTypographyHeadingSmLineHeight)',
      },
      md: {
        fontFamily: 'var(--sdTypographyHeadingMdFontFamily)',
        fontWeight: 'var(--sdTypographyHeadingMdFontWeight)',
        fontSize: 'var(--sdTypographyHeadingMdFontSize)',
        lineHeight: 'var(--sdTypographyHeadingMdLineHeight)',
      },
      lg: {
        fontFamily: 'var(--sdTypographyHeadingLgFontFamily)',
        fontWeight: 'var(--sdTypographyHeadingLgFontWeight)',
        fontSize: 'var(--sdTypographyHeadingLgFontSize)',
        lineHeight: 'var(--sdTypographyHeadingLgLineHeight)',
      },
      xl: {
        fontFamily: 'var(--sdTypographyHeadingXlFontFamily)',
        fontWeight: 'var(--sdTypographyHeadingXlFontWeight)',
        fontSize: 'var(--sdTypographyHeadingXlFontSize)',
        lineHeight: 'var(--sdTypographyHeadingXlLineHeight)',
      },
      hero: {
        fontFamily: 'var(--sdTypographyHeadingHeroFontFamily)',
        fontWeight: 'var(--sdTypographyHeadingHeroFontWeight)',
        fontSize: 'var(--sdTypographyHeadingHeroFontSize)',
        lineHeight: 'var(--sdTypographyHeadingHeroLineHeight)',
      },
    },
  },
  sizing: {
    '0': 'var(--sdSizing0)',
    '25': 'var(--sdSizing25)',
    '50': 'var(--sdSizing50)',
    '100': 'var(--sdSizing100)',
    '200': 'var(--sdSizing200)',
    '250': 'var(--sdSizing250)',
    '300': 'var(--sdSizing300)',
    '400': 'var(--sdSizing400)',
    '500': 'var(--sdSizing500)',
    '600': 'var(--sdSizing600)',
    '700': 'var(--sdSizing700)',
  },
  spacing: {
    xxxs: 'var(--sdSpacingXxxs)',
    xxs: 'var(--sdSpacingXxs)',
    xs: 'var(--sdSpacingXs)',
    sm: 'var(--sdSpacingSm)',
    md: 'var(--sdSpacingMd)',
    lg: 'var(--sdSpacingLg)',
    xl: 'var(--sdSpacingXl)',
    xxl: 'var(--sdSpacingXxl)',
    xxxl: 'var(--sdSpacingXxxl)',
  },
  boxShadow: {
    xs: {
      x: 'var(--sdBoxShadowXsX)',
      y: 'var(--sdBoxShadowXsY)',
      blur: 'var(--sdBoxShadowXsBlur)',
      spread: 'var(--sdBoxShadowXsSpread)',
      color: 'var(--sdBoxShadowXscolor)',
    },
    xl: {
      x: 'var(--sdBoxShadowXlX)',
      y: 'var(--sdBoxShadowXlY)',
      blur: 'var(--sdBoxShadowXlBlur)',
      spread: 'var(--sdBoxShadowXlSpread)',
      color: 'var(--sdBoxShadowXlColor)',
    },
  },
  borderRadius: {
    none: 'var(--sdBorderRadiusNone)',
    xs: 'var(--sdBorderRadiusXs)',
    sm: 'var(--sdBorderRadiusSm)',
    md: 'var(--sdBorderRadiusMd)',
    round: 'var(--sdBorderRadiusRound)',
  },
  borderWidth: {
    none: 'var(--sdBorderWidthNone)',
    sm: 'var(--sdBorderWidthSm)',
    md: 'var(--sdBorderWidthMd)',
    lg: 'var(--sdBorderWidthLg)',
  },
};




const theme = {
  // Colors
  colors: {
    BrandGrayDarker: 'var(--sdColorBrandGrayDarker)',
    BrandGrayDark: 'var(--sdColorBrandGrayDark)',
    BrandGray: 'var(--sdColorBrandGray)',
    BrandGrayLight: 'var(--sdColorBrandGrayLight)',
    BrandGrayLighter: 'var(--sdColorBrandGrayLighter)',
    BrandGrayLightest: 'var(--sdColorBrandGrayLightest)',
    BrandBlack: 'var(--sdColorBrandBlack)',
    BrandWhite: 'var(--sdColorBrandWhite)',
    primaryDark: 'var(--sdColorBrandGrayDarker)',
    primary: 'var(--sdColorBrandGrayDark)',
    primaryLight: 'var(--sdColorBrandGray)',
    secondaryDark: 'var(--sdColorBrandGrayLight)',
    secondary: 'var(--sdColorBrandGrayLighter)',
    secondaryLight: 'var(--sdColorBrandGrayLightest)',
    neutralDarkest: 'var(--sdColorBrandBlack)',
    neutralDarker: 'var(--sdColorBrandGrayDarker)',
    neutralDark: 'var(--sdColorBrandGrayDark)',
    neutral: 'var(--sdColorBrandGray)',
    neutralLight: 'var(--sdColorBrandGrayLight)',
    neutralLighter: 'var(--sdColorBrandGrayLighter)',
    neutralLightest: 'var(--sdColorBrandGrayLightest)',
    informationDark: 'var(--sdColorBrandBlack)',
    information: 'var(--sdColorBrandGrayDarker)',
    informationLight: 'var(--sdColorBrandGrayDark)',
    informationLighter: 'var(--sdColorBrandGray)',
    successDark: 'var(--sdColorBrandBlack)',
    success: 'var(--sdColorBrandGrayDarker)',
    successLight: 'var(--sdColorBrandGrayDark)',
    warningDarker: 'var(--sdColorBrandBlack)',
    warning: 'var(--sdColorBrandGrayDarker)',
    warningLight: 'var(--sdColorBrandGrayDark)',
    errorDark: 'var(--sdColorBrandBlack)',
    error: 'var(--sdColorBrandGrayDarker)',
    errorLight: 'var(--sdColorBrandGrayDark)',
    highlight: 'var(--sdColorBrandGray)',
    black: 'var(--sdColorBrandBlack)',
    white: 'var(--sdColorBrandWhite)'
  },

  // Text colors
  text: {
    headings: 'var(--sdColorTextBlack)',
    body: 'var(--sdColorTextBlack)', // Adjusted for readability in dark mode
    action: 'var(--sdColorBrandGrayLight)', // Adjusted for visibility in dark mode
    actionHover: 'var(--sdColorBrandGrayLightest)', // Adjusted for interaction feedback
    disabled: 'var(--sdColorBrandGrayLighter)', // Adjusted for disabled state in dark mode
    highlight: 'var(--sdColorBrandGrayLightest)', // Adjusted for highlighted text
    information: 'var(--sdColorBrandGrayLight)', // Adjusted for information text
    success: 'var(--sdColorBrandWhite)', // Adjusted for success text
    warning: 'var(--sdColorBrandGrayLightest)', // Adjusted for warning text
    error: 'var(--sdColorBrandGrayLightest)', // Adjusted for error text
    onAction: 'var(--sdColorBrandWhite)',
    onDisabled: 'var(--sdColorBrandGrayDark)' // Adjusted for disabled state interaction
  },

  // Icon colors
  icon: {
    primary: 'var(--sdColorBrandGrayLight)', // Adjusted for icon visibility in dark mode
    information: 'var(--sdColorBrandGrayLightest)', // Adjusted for information icon color
    success: 'var(--sdColorBrandWhite)', // Adjusted for success icon color
    warning: 'var(--sdColorBrandGrayLightest)', // Adjusted for warning icon color
    error: 'var(--sdColorBrandGrayLightest)' // Adjusted for error icon color
  },

  // Surface colors
  surface: {
    page: 'var(--sdColorBrandGrayBackground)', // Adjusted for overall page background in dark mode
    primary: 'var(sdColorBrandGrayLight)', // Adjusted for primary surface color in dark mode
    secondary: 'var(--sdColorBrandGrayLighte)', // Adjusted for secondary surface color in dark mode
    disabled: 'var(--sdColorBrandGrayLightest)', // Adjusted for disabled state surface color in dark mode
    success: 'var(--sdColorBrandGrayLight)', // Adjusted for success surface color in dark mode
    error: 'var(--sdColorBrandGrayLight)', // Adjusted for error surface color in dark mode
    warning: 'var(--sdColorBrandGrayLightest)', // Adjusted for warning surface color in dark mode
    information: 'var(--sdColorBrandGrayLighter)', // Adjusted for information surface color in dark mode
    highlight: 'var(--sdColorBrandGray)', // Adjusted for highlighted surface color in dark mode
    action1: 'var(--sdColorBrandGrayDark)', // Adjusted for primary action surface color in dark mode
    action1Hover: 'var(--sdColorBrandGray)', // Adjusted for primary action hover surface color in dark mode
    action2: 'rgba(0,0,0,0.0)', // Adjusted for secondary action surface color in dark mode
    action2Hover: 'var(--sdColorBrandGrayDark)', // Adjusted for secondary action hover surface color in dark mode
    modal: 'rgba(0,0,0,0.75)' // Adjusted for modal surface color in dark mode
  },

  // Border colors
  border: {
    primary: 'var(--sdDarkColorBrandGrayLighter)', // Adjusted for primary border color in dark mode
    secondary: 'var(--sdDarkColorBrandGrayDark)', // Adjusted for secondary border color in dark mode
    tertiary: 'rgba(0,0,0,0.2)', // Adjusted for tertiary border color in dark mode
    information: 'var(--sdDarkColorBrandGrayDarker)', // Adjusted for information border color in dark mode
    success: 'var(--sdDarkColorBrandGrayLight)', // Adjusted for success border color in dark mode
    warning: 'var(--sdDarkColorBrandGray)', // Adjusted for warning border color in dark mode
    error: 'var(--sdDarkColorBrandGrayDarker)', // Adjusted for error border color in dark mode
    highlight: 'var(--sdDarkColorBrandGray)', // Adjusted for highlight border color in dark mode
    disabled: 'var(--sdDarkColorBrandGray)', // Adjusted for disabled state border color in dark mode
    action: 'var(--sdDarkColorBrandGrayDark)', // Adjusted for action border color in dark mode
    actionHover: 'var(--sdDarkColorBrandGrayDarker)' // Adjusted for action hover border color in dark mode
  },

  // Focus colors
  focus: {
    primary: 'var(--sdDarkColorBrandGrayDarker)' // Adjusted for primary focus color in dark mode
  },

 
};

// Theme configuration object
export const themeConfig = {
  lightTheme: {
    ...theme,
  },
  darkTheme: {
    ...theme,
    text: {
      headings: 'var(--sdColorTextWhite)',
      body: 'var(--sdColorTextWhite)',
      action: 'var(--sdDarkColorBrandGrayLight)',
      actionHover: 'var(--sdDarkColorBrandGrayLightest)',
      disabled: 'var(--sdDarkColorBrandGrayLighter)',
      highlight: 'var(--sdDarkColorBrandGrayLightest)',
      information: 'var(--sdDarkColorBrandGrayLight)',
      success: 'var(--sdDarkColorBrandWhite)',
      warning: 'var(--sdDarkColorBrandGrayLightest)',
      error: 'var(--sdDarkColorBrandGrayLightest)',
      onAction: 'var(--sdDarkColorBrandWhite)',
      onDisabled: 'var(--sdDarkColorBrandGrayDark)'
    },
    icon: {
      primary: 'var(--sdDarkColorBrandGrayLight)',
      information: 'var(--sdDarkColorBrandGrayLightest)',
      success: 'var(--sdDarkColorBrandWhite)',
      warning: 'var(--sdDarkColorBrandGrayLightest)',
      error: 'var(--sdDarkColorBrandGrayLightest)'
    },
    surface: {
      page: 'var(--sdColorTextBlack)',
      primary: 'var(--sdColorBrandGray)',
      secondary: 'var(--sdColorBrandGrayLightest)', // Not overridden in dark mode
      disabled: 'var(--sdColorBrandGrayLightest)', // Not overridden in dark mode
      success: 'var(--sdColorBrandGrayLight)', // Not overridden in dark mode
      error: 'var(--sdColorBrandGrayLight)', // Not overridden in dark mode
      warning: 'var(--sdColorBrandGrayLightest)', // Not overridden in dark mode
      information: 'var(--sdColorBrandGrayLighter)', // Not overridden in dark mode
      highlight: 'var(--sdColorBrandGray)', // Not overridden in dark mode
      action1: 'var(--sdColorBrandGrayDark)', // Not overridden in dark mode
      action1Hover: 'var(--sdColorBrandGray)', // Not overridden in dark mode
      action2: 'rgba(0,0,0,0.0)', // Not overridden in dark mode
      action2Hover: 'var(--sdColorBrandGrayDark)', // Not overridden in dark mode
      modal: 'rgba(0,0,0,0.75)' // Not overridden in dark mode
    },
    border: {
      primary: 'var(--sdDarkColorBrandGray)',
      secondary: 'var(--sdDarkColorBrandGrayDark)',
      tertiary: 'rgba(0,0,0,0.2)',
      information: 'var(--sdDarkColorBrandGrayDarker)',
      success: 'var(--sdDarkColorBrandGrayLight)',
      warning: 'var(--sdDarkColorBrandGray)',
      error: 'var(--sdDarkColorBrandGrayDarker)',
      highlight: 'var(--sdColorBrandGray)', // Not overridden in dark mode
      disabled: 'var(--sdColorBrandGray)', // Not overridden in dark mode
      action: 'var(--sdDarkColorBrandGrayDark)',
      actionHover: 'var(--sdDarkColorBrandGrayDarker)'
    },
    focus: {
      primary: `{var(--sdDarkColorBrandGrayDarker)}`
    },
  }
};



